import React, { FC } from 'react';
import locale from 'antd/lib/date-picker/locale/ru_RU';

import { ArrowLeft2Outline, ArrowRight3Outline, Calendar1Outline } from 'ui/components/Icon';

import { StyledDatePicker, WrapperDatePicker, Styledlabel } from './styled';

import { DatePickerProps } from './types';

const DatePicker: FC<DatePickerProps> = ({ label, fullWidth, size, ...otherProps }) => {
  return (
    <WrapperDatePicker>
      {label && <Styledlabel>{label}</Styledlabel>}
      <StyledDatePicker $fullWidth={fullWidth} $size={size} {...otherProps} />
    </WrapperDatePicker>
  );
};

DatePicker.defaultProps = {
  format: 'DD.MM.YYYY',
  placeholder: 'Выберите',
  suffixIcon: <Calendar1Outline />,
  nextIcon: <ArrowRight3Outline />,
  prevIcon: <ArrowLeft2Outline />,
  locale: locale,
  showToday: false,
  getPopupContainer: node => node || document.body,
};

export default DatePicker;
